import { ReactNode } from 'react';

import { match } from 'ts-pattern';

import addProtocolToUrl from 'lib/common/components/molecules/RichTextEditor/Toolbar/utils/addProtocolToUrl';

import {
  ATTACHED_DATA_VALUE_TYPES,
  parseAttachedDataValue,
} from 'lib/common/utils/attachedData/parseAttachedDataValue';

import Text from '../../Text';
import AudioPlayer from './components/AudioPlayer';

const MAILTO_PREFIX_REGEX = /^mailto:/;

interface IAttachedDataValue {
  data: string;
  linkClassName?: string;
  renderText: (data: string) => ReactNode;
}

export default function AttachedDataValue({ data, linkClassName, renderText }: IAttachedDataValue) {
  const parsedValue = parseAttachedDataValue(data);

  return match(parsedValue)
    .with({ type: ATTACHED_DATA_VALUE_TYPES.AUDIO }, (value) => <AudioPlayer src={value.url} />)
    .with(
      { type: ATTACHED_DATA_VALUE_TYPES.MARKDOWN_LINK },
      { type: ATTACHED_DATA_VALUE_TYPES.LINK },
      (value) => (
        <Text type="link" className={linkClassName} rel="noreferrer" href={addProtocolToUrl(value.url)}>
          {value.type === ATTACHED_DATA_VALUE_TYPES.MARKDOWN_LINK
            ? value.text
            : data.replace(MAILTO_PREFIX_REGEX, '')}
        </Text>
      ),
    )
    .otherwise(() => <>{renderText(data)}</>);
}
